<script>

	import { onMount } from 'svelte';
	import { fade, fly } from 'svelte/transition';

	import cssVars from 'svelte-css-vars';

	import Results from "../Now/Session/Interactions/Polls/Results.svelte";

	import { event, spotlight } from '../lib/stores.js';

	let mounted = false;
	let msg = $spotlight;
	let pollVars = {};

	onMount(async () => {
		pollVars = {
			opts: msg.poll.options.length
		};
		mounted = true;
	});

</script>

<style>
	#spotlight {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: grid;
		place-content: center;
		font-size: calc(2.8rem - (0.25rem * var(--opts)));
		cursor: none;
	}
	#spotlight:before {
		content: '';
		position: absolute;
		inset: 0;
		background: var(--bgColor);
	}
	.msg {
		position: relative;
		box-sizing: border-box;
		padding: 1em;
		width: 78vw;
	}
</style>

{#if mounted}
	<!-- svelte-ignore a11y-click-events-have-key-events -->
	<div id="spotlight" in:fade={{ duration: 300 }} on:click={() => { $spotlight = null }} use:cssVars={pollVars} >

		<div
			class="msg"
			in:fly={{ duration: 400, y: 20, delay: 200 }}
		>
			<Results
				poll={msg.poll}
				results={msg.results}
			/>
		</div>

	</div>
{/if}